module.exports = __webpack_public_path__ + "img/dongji_ps_05.f9c0860f.jpg";